export default __webpack_public_path__ + "static/media/blush-cold-winter.ceea68a3.png";